import { Form } from "../../../system/useForm";
import { Box, Typography } from "@mui/material";
import FormYesNo from "../../../Components/FormYesNo";

interface Props {
	form: Form
	canEditDetails?: boolean
}

const StepAdditional = ({ form, canEditDetails = true }: Props) => {
	return (
		<Box>
			<Box mb={2}>
				<FormYesNo
					name="isPoolfleet"
					label="Handelt es sich um ein ALD Flex Fahrzeug?"
					form={form}
					options={{ required: true }}
				/>
			</Box>
			<Box sx={{ visibility: canEditDetails ? "visible" : "hidden" }}>
				<Box mt={2}>
					<Typography variant="h6" gutterBottom>
						Abmeldung
					</Typography>
				</Box>
				<Box>
					<FormYesNo
						name="doUnregistration"
						label="Soll das Auto abgemeldet werden?"
						form={form}
						options={{
							required: true
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
}

export default StepAdditional;
